<template>
  <div class="">
    <div class="flex alit">
      <div class="">
        <div class="flex">
          <div class="flexCol alit" style="margin: 0 5vw 0 5vw">
            <img
              class="ai-list-icon"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E5%9C%9F%E5%A3%A4%E5%AF%BC%E7%94%B5%E7%8E%87%402x.png"
              alt=""
            />
            <div class="ai-list-number">{{ needWaterData.cableRate }}</div>
            <div class="ai-list-title">土壤导电率</div>
          </div>
          <div class="flexCol alit">
            <img
              class="ai-list-icon"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E5%9C%9F%E5%A3%A4%E4%B8%8A%E5%B1%82%E6%B8%A9%E5%BA%A6%402x.png"
              alt=""
            />
            <div class="ai-list-number">{{ needWaterData.upTemp }}</div>
            <div class="ai-list-title">土壤上层温度</div>
          </div>
        </div>
        <div class="flex" style="margin-top: 7%">
          <div class="flexCol alit" style="margin: 0 5vw 0 0vw">
            <img
              class="ai-list-icon"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E5%9C%9F%E5%A3%A4PH%402x.png"
              alt=""
            />
            <div class="ai-list-number">{{ needWaterData.phValue }}</div>
            <div class="ai-list-title">土壤PH</div>
          </div>
          <div class="flexCol alit">
            <img
              class="ai-list-icon"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E5%9C%9F%E5%A3%A4%E4%B8%8A%E5%B1%82%E6%B9%BF%E5%BA%A6%402x.png"
              alt=""
            />
            <div class="ai-list-number">{{ needWaterData.upHum }}</div>
            <div class="ai-list-title">土壤上层湿度</div>
          </div>
        </div>
      </div>
      <div class="flexCol alit" style="margin: 0 -4vw">
        <img
          src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E4%B8%AD%E9%97%B4%E5%9B%BE%E6%A0%87%402x.png"
          class="center-ai"
          alt=""
        />
        <div class="start">
          <div class="starttext" @click="startCompute">开始计算</div>
        </div>
      </div>
      <div class="">
        <div class="flex">
          <div class="flexCol alit" style="margin: 0 5vw 0 0vw">
            <img
              class="ai-list-icon"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E5%9C%9F%E5%A3%A4%E4%B8%AD%E5%B1%82%E6%B8%A9%E5%BA%A6%402x.png"
              alt=""
            />
            <div class="ai-list-number">{{ needWaterData.inTemp }}</div>
            <div class="ai-list-title">土壤中层温度</div>
          </div>
          <div class="flexCol alit">
            <img
              class="ai-list-icon"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E5%9C%9F%E5%A3%A4%E4%B8%AD%E5%B1%82%E6%B9%BF%E5%BA%A6%402x.png"
              alt=""
            />
            <div class="ai-list-number">{{ needWaterData.inHum }}</div>
            <div class="ai-list-title">土壤中层湿度</div>
          </div>
        </div>
        <div class="flex" style="margin-top: 7%">
          <div class="flexCol alit" style="margin: 0 5vw 0 5vw">
            <img
              class="ai-list-icon"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E5%9C%9F%E5%A3%A4%E4%B8%8B%E5%B1%82%E6%B8%A9%E5%BA%A6%402x.png"
              alt=""
            />
            <div class="ai-list-number">{{ needWaterData.downTemp }}</div>
            <div class="ai-list-title">土壤下层温度</div>
          </div>
          <div class="flexCol alit">
            <img
              class="ai-list-icon"
              src="https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E5%9C%9F%E5%A3%A4%E4%B8%8B%E5%B1%82%E6%B9%BF%E5%BA%A6%402x.png"
              alt=""
            />
            <div class="ai-list-number">{{ needWaterData.downHum }}</div>
            <div class="ai-list-title">土壤下层湿度</div>
          </div>
        </div>
      </div>
    </div>
    <div class="title" style="margin-top: 2%">根据当前数据计算得出</div>
    <div class="flex">
      <div class="flexCol">
        <div class="jy-title">建议灌溉时间:</div>
        <div class="jy-content">
          <div class="jy-content-text">{{ startData.nextDate }}</div>
        </div>
      </div>
      <div class="flexCol" style="margin: 0 1%">
        <div class="jy-title">建议灌溉量（亩均）:</div>
        <div class="jy-content">
          <div class="jy-content-text">{{ startData.nextWater }}</div>
        </div>
      </div>
      <div class="flexCol">
        <div class="jy-title">建议总灌水量:</div>
        <div class="jy-content">
          <div class="jy-content-text">{{ startData.sumWater }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    needWaterData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      startData: {},
    };
  },
  methods: {
    startCompute() {
      const loading = this.$loading({
        lock: true,
        text: "计算中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
        this.startData.nextDate = this.needWaterData.nextDate;
        this.startData.nextWater = this.needWaterData.nextWater;
        this.startData.sumWater = this.needWaterData.sumWater;
        this.$forceUpdate();
      }, 2000);
    },
  },
  mounted() {},
  watch: {
    needWaterData(newVal) {
      this.startData = {};
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
.jy-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #adcbdf;
  margin-top: 50px;
}
.jy-content {
  margin-top: 20px;
  width: 410px;
  height: 70px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E7%BB%93%E6%9E%9C%E8%83%8C%E6%99%AF%402x.png");
  background-size: 100% 100%;
  .jy-content-text {
    font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 36px;
    color: #f6f9fe;
    line-height: 70px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    background: linear-gradient(90deg, #ffffff 15%, #f7ff57 81%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.start {
  width: 400px;
  height: 70px;
  background-image: url("https://ica.obs.cn-south-1.myhuaweicloud.com/screen/%E6%99%BA%E6%85%A7%E6%B0%B4%E5%8A%A1/Ai/%E5%BC%80%E5%A7%8B%E8%AE%A1%E7%AE%97%E8%83%8C%E6%99%AF%402x.png");
  background-size: 100% 100%;
  margin-top: -130px;
  cursor: pointer;
  margin-left: 30px;
  .starttext {
    font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 36px;
    line-height: 70px;
    text-shadow: 0px 3px 7px rgba(53, 44, 0, 0.5);
    text-align: center;
    font-style: normal;
    text-transform: none;
    background: linear-gradient(90deg, #ad9914 0%, #1b1804 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
}
.center-ai {
  width: 540px;
  height: 430px;
}
.ai-list-title {
  font-family: JiangChengXieHei, JiangChengXieHei;
  font-size: 18px;
  color: #c5dfef;
}
.ai-list-number {
  font-family: ddingproBlob;
  font-weight: 400;
  font-size: 18px;
  color: #ffffff;
}
.ai-list-icon {
  width: 90px;
  height: 90px;
}
</style>
